import { render } from "./PdfModal.vue?vue&type=template&id=70787fac&scoped=true&ts=true"
import script from "./PdfModal.vue?vue&type=script&lang=ts"
export * from "./PdfModal.vue?vue&type=script&lang=ts"

import "./PdfModal.vue?vue&type=style&index=0&id=70787fac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70787fac"]])

export default __exports__